import * as React from "react";
import { SortableContainer, SortEndHandler } from "react-sortable-hoc";
import SortableItem from "./sortableList/SortableItem";

interface ISortableListProps<T> {
  items: T[];
  renderItem: (value: T) => React.ReactNode;
  onOrderChange: SortEndHandler;
  useDragHandle?: boolean;
}

export default class SortableList<T> extends React.PureComponent<
  ISortableListProps<T>
> {
  private SortableList = SortableContainer(({ items }: any) => {
    return (
      <div>
        {items.map((item: any, index: number) => (
          <SortableItem
            key={item.localId !== undefined ? item.localId : item.id}
            item={item}
            index={index}
            renderItem={this.props.renderItem}
          />
        ))}
      </div>
    );
  });

  public render() {
    const { items, onOrderChange, useDragHandle } = this.props;
    return (
      <div>
        <this.SortableList
          useDragHandle={useDragHandle}
          lockAxis="y"
          items={items}
          onSortEnd={onOrderChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SortableList.tsx